import { get, capitalize } from 'lodash';

export default (error, field) =>
  capitalize(get(error, `graphQLErrors.0.details.${field}`, ''));
